var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: "",
                        size: "small",
                        "label-width": "90px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品分类" } },
                        [
                          _c("el-cascader", {
                            staticClass: "selWidth ",
                            attrs: {
                              options: _vm.merCateList,
                              props: _vm.props,
                              clearable: "",
                              size: "small",
                            },
                            on: { change: _vm.handerSearch },
                            model: {
                              value: _vm.listPram.cateId,
                              callback: function ($$v) {
                                _vm.$set(_vm.listPram, "cateId", $$v)
                              },
                              expression: "listPram.cateId",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品品牌" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                clearable: "",
                                placeholder: "请选择",
                                filterable: "",
                                "filter-method": _vm.handleAgreementSearch,
                              },
                              on: { change: _vm.handerSearch },
                              model: {
                                value: _vm.listPram.brandId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "brandId", $$v)
                                },
                                expression: "listPram.brandId",
                              },
                            },
                            _vm._l(_vm.brandOption, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.brandStr, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "供应商" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                clearable: "",
                                placeholder: "请选择",
                                filterable: "",
                                "filter-method": _vm.handleSupplierSearch,
                              },
                              on: { change: _vm.handerSearch },
                              model: {
                                value: _vm.listPram.supplierId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "supplierId", $$v)
                                },
                                expression: "listPram.supplierId",
                              },
                            },
                            _vm._l(_vm.supplierOption, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.supplierName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth ",
                              attrs: { clearable: "", placeholder: "请选择" },
                              on: { change: _vm.handerSearch },
                              model: {
                                value: _vm.listPram.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "status", $$v)
                                },
                                expression: "listPram.status",
                              },
                            },
                            _vm._l(_vm.thirdOrderStateOption, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单编号" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                placeholder: "请输入订单编号",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.orderNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "orderNo", $$v)
                                },
                                expression: "listPram.orderNo",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "客户单号" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                placeholder: "请输入",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.outOrderNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "outOrderNo", $$v)
                                },
                                expression: "listPram.outOrderNo",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "关联账户" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                placeholder: "请输入",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.related,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "related", $$v)
                                },
                                expression: "listPram.related",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单时间" } },
                        [
                          _c("el-date-picker", {
                            staticClass: "selWidth ",
                            attrs: {
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              type: "datetimerange",
                              "range-separator": "-",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                            },
                            on: { change: _vm.handerSearch },
                            model: {
                              value: _vm.listPram.dataRenage,
                              callback: function ($$v) {
                                _vm.$set(_vm.listPram, "dataRenage", $$v)
                              },
                              expression: "listPram.dataRenage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", "min-width": "50" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderNo",
                  label: "订单编号",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "virtualStatusName",
                  label: "订单状态",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "skuName",
                  label: "产品名称",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "cateName",
                  label: "商品分类",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "related",
                  label: "关联账号",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _c("span", {}, [
                        _vm._v(_vm._s(_vm._transportTem(scope.row.related))),
                      ])
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "price", label: "商品金额", "min-width": "100" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "supplierPrice",
                  label: "供应扣费",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "customerPrice",
                  label: "客户扣费",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "supplierName",
                  label: "供应商",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "customerName",
                  label: "客户",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "supplierNo",
                  label: "供应单号",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "customerNo",
                  label: "客户单号",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "updateTime",
                  label: "更新时间",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "80",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openOrderDetail(scope.row.orderNo)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("ThirdOrderDetail", {
        ref: "OrderDetailRef",
        on: { doRefresh: _vm.handerSearch },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }